import { FC } from 'react';

import Image from '@/components/image';
import { ThemeSettings } from '@/types/views/generic';

interface ThemeLogoProps {
  themeSettings: ThemeSettings;
}

const ThemeLogo: FC<ThemeLogoProps> = ({ themeSettings }) => {
  if (!themeSettings.logo && !themeSettings.logoMobile) return null;

  return (
    <>
      {themeSettings.logo && (
        <div className="hidden xl:block">
          <Image
            src={themeSettings.logo.src}
            useIntrinsicSize
            width={themeSettings.logo.width}
            height={themeSettings.logo.height}
            alt={`${themeSettings.title || ''} - Logo`}
          />
        </div>
      )}

      {themeSettings.logoMobile && (
        <div className="block xl:hidden">
          <Image
            src={themeSettings.logoMobile.src}
            useIntrinsicSize
            width={themeSettings.logoMobile.width}
            height={themeSettings.logoMobile.height}
            alt={`${themeSettings.title || ''} - Logo`}
          />
        </div>
      )}
    </>
  );
};

export default ThemeLogo;
